import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { STORED_PATHNAME_KEY } from '../constants';

function UnauthenticatedRedirection(props) {
    const {} = props,
        { pathname } = useLocation();

    useEffect(() => {
        console.log('When logged back in, redirect to: ', pathname);
        sessionStorage.setItem(STORED_PATHNAME_KEY, pathname);
    }, []);

    return <Redirect to="/" />;
}

export default UnauthenticatedRedirection;
